import AuthStorage from "./types/Storage"

export default class Storage<T> implements AuthStorage {
  key: string

  constructor(key: string) {
    this.key = key
  }

  get: AuthStorage<T>["get"] = async () => {
    try {
      const item = localStorage.getItem(this.key)
      return JSON.parse(item || "{}")
    } catch {
      return {}
    }
  }

  set: AuthStorage<T>["set"] = async (auth) => {
    try {
      localStorage.setItem(this.key, JSON.stringify(auth))
    } catch {
      // storage blocked
    }
    return true
  }

  clear: AuthStorage<T>["clear"] = async () => {
    try {
      localStorage.setItem(this.key, "{}")
    } catch {
      // storage blocked
    }
    return true
  }
}
